<template>
    <div class="mobileorderhistory">
        <template v-for="(nh, index) in groupedhistory">
                <div :key="index" class="historyItem">

                    <b-container>
                        <h1>{{ nh.date | formatreldate }}</h1>

                         <template v-for="(nt, index) in nh.orders">
                            <b-card :key="index + 'trail'" no-body class="mb-1">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <div
                                        v-b-toggle="`orderHistory-${nt.id}`"
                                        class="historyTrail"
                                    >
                                        <div class="trailTime">
                                            {{ nt.created_at | formatdate("hh:mm A") }}
                                        </div>

                                        <div class="tailDetails">
                                            <template
                                                v-if="
                                                    nt.assign_order &&
                                                    nt.assign_order.assign_to.avatar
                                                "
                                            >
                                                <div
                                                    :style="`background-image : url(${nt.assign_order.assign_to.avatar});`"
                                                    class="deliveryImage"
                                                ></div>
                                            </template>

                                            <div class="historyDetail">
                                                <h3>
                                                    {{ nt.contact_name }}
                                                    <span class="dozen"
                                                        >{{ nt.numberofboxes }} Dozen</span
                                                    >
                                                </h3>
                                                <p>
                                                    {{ nt.shipping_address_street }}
                                                    {{ nt.shipping_address_city }}
                                                    {{ nt.shipping_address_state }}
                                                    {{ nt.shipping_address_zipcode }}
                                                </p>
                                            </div>

                                            <span class="collapseIcon">
                                                <b-icon icon="chevron-up"> </b-icon>

                                                <b-icon icon="chevron-down"></b-icon>
                                            </span>
                                        </div>
                                    </div>
                                </b-card-header>

                                <b-collapse
                                    :id="`orderHistory-${nt.id}`"
                                    accordion="my-accordion"
                                    role="tabpanel"
                                >
                                    <b-card-body>
                                        <div class="orderTrail">
                                            <div class="orderTrailItem">
                                                <span class="trailType done">
                                                    <b-icon
                                                        icon="file-earmark-text-fill"
                                                    ></b-icon>
                                                </span>

                                                <div class="trailDetails">
                                                    <h4>Order created</h4>
                                                    <p>
                                                        {{
                                                            nt.created_at
                                                                | forceformatdate(
                                                                    "hh:mm A, MMM D YYYY"
                                                                )
                                                        }}
                                                    </p>
                                                </div>
                                            </div>

                                            <div class="orderTrailItem">
                                                <span
                                                    :class="[
                                                        'trailType',
                                                        { done: nt.assign_order },
                                                    ]"
                                                >
                                                    <b-icon icon="person-fill"></b-icon>
                                                </span>

                                                <div class="trailDetails">
                                                    <h4>
                                                        Assigned to
                                                        {{
                                                            nt.assign_order
                                                                ? nt.assign_order.assign_to.name
                                                                : ""
                                                        }}
                                                    </h4>
                                                    <p>
                                                        {{
                                                            nt.assign_order
                                                                ? nt.assign_order.created_at
                                                                : ""
                                                                | forceformatdate(
                                                                    "h:mm A, MMM D YYYY"
                                                                )
                                                        }}
                                                    </p>
                                                </div>
                                            </div>

                                            <div class="orderTrailItem">
                                                <span
                                                    :class="[
                                                        'trailType',
                                                        { done: nt.status != 'assign' },
                                                    ]"
                                                >
                                                    <b-icon icon="check"></b-icon>
                                                </span>

                                                <div class="trailDetails">
                                                    <h4>Accepted</h4>
                                                    <template v-if="nt.status != 'assign'">
                                                        <p>
                                                            {{
                                                                accepteddate(nt)
                                                                    | forceformatdate(
                                                                        "h:mm A, MMM D YYYY"
                                                                    )
                                                            }}
                                                        </p>
                                                    </template>

                                                    <template v-else>
                                                        <p>Pending</p>
                                                    </template>
                                                </div>
                                            </div>

                                            <template
                                                v-for="(amend, index) in amendstatuses(nt)"
                                            >
                                                <div
                                                    :key="index"
                                                    class="orderTrailItem amendstatuses"
                                                >
                                                    <span :class="[`trailType`, 'done']">
                                                        <b-icon icon="pen-fill"></b-icon>
                                                    </span>

                                                    <div :class="[`trailDetails orderstatus`]">
                                                        <h4>Amended</h4>
                                                        <p class="mb-0">
                                                            {{
                                                                amend.created_at
                                                                    | forceformatdate(
                                                                        "h:mm A, MMM D YYYY"
                                                                    )
                                                            }}
                                                        </p>
                                                        <p>{{ amend.notes }}</p>
                                                    </div>
                                                </div>
                                            </template>

                                            <div class="orderTrailItem">
                                                <span
                                                    :class="[
                                                        'trailType',
                                                        {
                                                            done:
                                                                nt.status == 'delivered' ||
                                                                nt.status == 'confirm',
                                                        },
                                                    ]"
                                                >
                                                    <b-icon icon="box-seam"></b-icon>
                                                </span>

                                                <div class="trailDetails">
                                                    <h4>Delivered</h4>

                                                    <template
                                                        v-if="
                                                            nt.status == 'delivered' ||
                                                            nt.status == 'confirm'
                                                        "
                                                    >
                                                        <p>
                                                            {{
                                                                delivereddate(nt)
                                                                    | forceformatdate(
                                                                        "h:mm A, MMM D YYYY"
                                                                    )
                                                            }}
                                                        </p>
                                                    </template>

                                                    <template v-else>
                                                        <p>
                                                            ETA
                                                            {{
                                                                nt.order_event_time_range
                                                                    ? `${nt.order_event_time_range}, `
                                                                    : ""
                                                            }}
                                                            {{
                                                                nt.delivery_date
                                                                    | formatdate("MMM D")
                                                            }}
                                                        </p>
                                                    </template>
                                                </div>

                                                <template
                                                    v-if="
                                                        nt.status == 'delivered' ||
                                                        nt.status == 'confirm'
                                                    "
                                                >
                                                    <div class="trailAction pl-5">
                                                        <button
                                                            @click.prevent="
                                                                checkammendstatus(nt),
                                                                $bvModal.show(
                                                                    'cancelDeliverHistory'
                                                                )
                                                            "
                                                            class="btn btn-outline-primary"
                                                        >
                                                            Amend
                                                        </button>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>

                                        <div class="deliveryProof">
                                            <img :src="getdeliverimg(nt)" alt="" />
                                        </div>

                                        <div class="orderContactDetails">
                                            <div class="contactItem">
                                                <b-icon icon="telephone-fill"></b-icon>
                                                {{ nt.phone_number | VMask("(###) ###-####") }}
                                            </div>

                                            <div class="contactItem">
                                                <b-icon icon="calendar"></b-icon>
                                                {{
                                                    nt.order_event_time_range
                                                        ? `${nt.order_event_time_range}, `
                                                        : ""
                                                }}
                                                {{ nt.delivery_date | formatdate("MMM D") }}
                                            </div>

                                            <div class="contactItem">
                                                <b-icon icon="geo-alt"></b-icon>
                                                {{ nt.shipping_address_street }}
                                                {{ nt.shipping_address_city }}
                                                {{ nt.shipping_address_state }}
                                                {{ nt.shipping_address_zipcode }}
                                            </div>

                                            <div class="contactItem">
                                                <div class="orderNote">
                                                    {{
                                                        nt.order_notes
                                                            ? nt.order_notes
                                                            : "No notes"
                                                    }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="orderSummary">
                                            <div class="orderSummaryHeader">
                                                <b-row>
                                                    <b-col cols="9">
                                                        <h4>
                                                            Order {{ nt.order_number }} summary
                                                        </h4>
                                                    </b-col>

                                                    <b-col cols="3 dozen">
                                                        {{ nt.numberofboxes }} Dozen
                                                    </b-col>
                                                </b-row>
                                            </div>

                                            <div class="orderBreakdown">
                                                <template
                                                    v-for="(box, index) in grouporderbox(
                                                        nt.orderboxitems
                                                    )"
                                                >
                                                    <div
                                                        :key="index"
                                                        class="orderBreakdownItem"
                                                    >
                                                        <div
                                                            @click="
                                                                expandflavor =
                                                                    expandflavor == index
                                                                        ? null
                                                                        : index
                                                            "
                                                            class="orderboxheader"
                                                        >
                                                            <span class="orderNumber">{{
                                                                box.count
                                                            }}</span>
                                                            -
                                                            <span class="boxname"
                                                                >{{ box.box_name }}
                                                            </span>
                                                            <span class="expand">
                                                                <template
                                                                    v-if="expandflavor == index"
                                                                >
                                                                    <b-icon
                                                                        icon="chevron-up"
                                                                    ></b-icon>
                                                                </template>

                                                                <template v-else>
                                                                    <b-icon
                                                                        icon="chevron-down"
                                                                    ></b-icon>
                                                                </template>
                                                            </span>
                                                        </div>

                                                        <div
                                                            v-if="expandflavor == index"
                                                            class="flavorlist"
                                                        >
                                                            <template
                                                                v-for="(
                                                                    flavor, index
                                                                ) in groupflavors(box.flavors)"
                                                            >
                                                                <div
                                                                    :key="index"
                                                                    class="flavorname"
                                                                >
                                                                    {{ flavor.name }}
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                        </template>
                    </b-container>
                </div>
            </template>

       
    </div>
</template>

<script>
/**
 * Declerations
 */
// MIXINS
import {adminorderhistorymixins} from '@/mixins/adminorderhistorymixins'

export default {
    mixins : [adminorderhistorymixins],
    data() {
        return {
            expandflavor  : null,
        }
    },
    mounted() {
        // Google map
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
        });
    },
};

// /**
//  * Declerations
//  */
// // Plugins
// import moment from "moment";

// // Helpers
// import Helper from "@/helpers/helper";

// // mixins
// import { ordermixins } from "@/mixins/ordermixins";
// import { orderboxmixins } from "@/mixins/orderboxmixins";

// export default {
//     mixins: [ordermixins, orderboxmixins],
//     props: {
//         orders: {
//             type: Array,
//             default: () => []
//         },
//         amendingorder: {
//             type: Object,
//             default: () => null
//         },
//         changestatus: {
//             type: Boolean,
//             default: () => true
//         },
//     },
//     data() {
//         return {
//             expandflavor  : null,
//         }
//     },
//     filters: {
//         /**
//          * Format date by
//          * @param format
//          */
//         formatdate(date, format) {
//             return date ? Helper.formatdate(date, format) : "";
//         },
//         /**
//          * Force format date by
//          * @param format
//          */
//         forceformatdate(date, format) {
//             return date ? Helper.formatdate(date, format, true) : "";
//         },
//         /**
//          * Format date by relation like
//          * Today, Tomorrow, and MM/DD/YYYY
//          */
//         formatreldate(date) {
//             return Helper.datestring(date);
//         },
//     },
//     methods: {
//         /**
//          * Get accepted date
//          */
//         accepteddate(order) {
//             const status = order.orderstatuses.find(
//                 (s) => s.status == "accepted"
//             );
//             return status ? status.created_at : "";
//         },
//         /**
//          * Get delivered date
//          */
//         delivereddate(order) {
//             const status = order.orderstatuses.find(
//                 (s) => s.status == "delivered"
//             );

//             return status ? status.created_at : "";
//         },
//         /**
//          * Group order boxes and flavors
//          */
//         grouporderbox(orders) {
//             const orderlist = Object.values(orders);

//             const group = this.groupboxorder(orderlist);

//             return group;
//         },

//         /**
//          * Get amend statuses
//          *
//          */
//         amendstatuses(order) {
//             let amendlist = order.orderstatuses.filter((s) =>
//                 s.status.match(/amend/i)
//             );

//             return amendlist
//                 .slice()
//                 .sort(
//                     (a, b) => new Date(a.updated_at) - new Date(b.updated_at)
//                 );
//         },
//         /**
//          * Get delivery proof
//          */
//         getdeliverimg(order) {
//             if (order.status == "delivered" || order.status == "confirm") {
//                 const status = order.orderstatuses.find(
//                     (s) => s.status == "delivered"
//                 );

//                 return status ? status.status_image : "";
//             } else {
//                 return "";
//             }
//         },
//         /**
//          * Check if ammend update status will be available after 24 hours after last delivery
//          *
//          */
//         checkammendstatus(order) {
//             this.$emit('update:amendingorder', order)
//             setTimeout(() => {
//                 const deliverydate = this.amendingorder.orderstatuses.find(
//                     (s) => s.status == "delivered"
//                 );

//                 if (deliverydate) {
//                     const status = this.pastduration(
//                         deliverydate.created_at,
//                         12
//                     );

//                     this.$emit('update:changestatus', status)
//                 }
//             }, 300);
//         },
//         /**
//          * Check if delivered today
//          * then show amend button only when it delivered today
//          */
//         checkiftoday(order) {
//             const deliverydate = this.delivereddate(order);

//             return deliverydate
//                 ? moment(deliverydate).isSame(moment(), "day")
//                 : false;
//         },
//         /**
//          * Group same flavors
//          */
//         groupflavors(flavors) {
//             return flavors.filter(
//                 (value, index, self) =>
//                     index ==
//                     self.findIndex((t) => t.flavor_id == value.flavor_id)
//             );
//         },
//     },
// };
</script>

<style lang="scss">
@import "@/scss/partials/_colors.scss";
@import "@/scss/partials/_mixins.scss";

.mobileorderhistory {

    .orderTrail {
          padding-left : 30px;
  
          .amendstatuses {
              svg {
                  font-size : 14px;
              }
              
              .orderstatus {
  
          
                  p {
                      text-transform: none;
                  }
              }
          }
  
          .orderTrailItem {
              display    : flex;
              border-left: 1px solid $lightgrey2;
              
              &:last-child {
                  border : none;
              }
  
              .trailType {
                  width           : 50px;
                  height          : 50px;
                  flex            : 0 0 50px;
                  margin-right    : 15px;
                  margin-left     : -25px;
                  border-radius   : 100%;
                  display         : flex;
                  align-items     : center;
                  justify-content : center;
                  background-color: $lightgrey;
                  font-size       : 25px;
  
                  &.done {
                      background-color: $primaryColor;
                      color           : white;
                  }
              }
  
              .trailDetails {
                  h4 {
                      font-size    : 20px;
                      font-weight  : 700;
                      margin-bottom: 0;
                  }
              }
  
              .trailAction {
                  .btn {
                      width  : 130px;
                      height : 40px;
                      padding: 0;
                  }
              }
          }
      }
  
      .historyTrail {
          display: flex;
          padding-top: 15px;
          padding-bottom: 15px;
  
          .trailTime {
              color: $grey;
              margin-right: 15px;
              display: block;
              white-space: nowrap;
          }
  
          .tailDetails {
              display: flex;
              width  : 100%;
  
              .deliveryImage {
                  flex               : 0 0 50px;
                  width              : 50px;
                  height             : 50px;
                  display            : block;
                  border-radius      : 100%;
                  background-size    : cover;
                  background-position: center;
                  margin-right       : 15px;
  
                   svg {
                      border-radius: 100%;
                      width        : 100%;
                      height       : 100%;
                      border       : 1px solid $grey;
                      padding      : 15px;
  
                      &.b-icon.bi {
                          color : $grey;
                      }
                  }
              }
  
              h3 {
                  font-size: 18px;
                  font-weight: 700;
                  margin-bottom: 0;
              }
  
              p {
                  color: $grey;
                  margin-bottom: 0;
              }
          }
      }
  
      .collapse {
          &.show {
              border-bottom : 10px solid $lightgrey;
          }
      }
  
      .accordion {
          .card {
              header {
  
                  .collapseIcon {
                      flex : 0 0 30px;
                      visibility: visible;
  
                      svg {
                          margin-left: auto;
                      }
                  }
  
                  .historyDetail {
                      flex : 1;
                  }
  
                  .collapsed {
                      svg {
                          &:first-child {
                              display: none;
                          }
                      }
                  }
  
                  .not-collapsed {
                      width : 100%;
                      
                      .deliveryImage {
                          // display: none;
                      }
  
                      svg {
                          &:last-child {
                              display: none;
                          }
                      }
                  }
              }
          }
      }
      
  
      .deliveryProof {
          margin-bottom : 20px;
  
          img {
              width       : 100%;
              max-width   : 300px;
              margin-left : auto;
              margin-right: auto;
              display     : table;
          }
      }
  
      .orderContactDetails {
          border-top   : 1px solid $lightgrey2;
          border-bottom: 1px solid $lightgrey2;
          padding      : 30px 0;
          color        : $grey;
  
          .contactItem {
              margin-bottom : 10px;
  
              .orderNote {
                  background-color: lighten($color: $primaryColor, $amount: 59);
                  padding         : 15px;
              }
          }
      }
  
      .orderSummary {
          padding-top : 30px;
  
          .orderSummaryHeader {
              margin-bottom : 20px;
  
              h4 {
                  font-size    : 18px;
                  font-weight  : 800;
                  margin-bottom: 0;
              }
  
              .dozen {
                  font-weight: 800;
                  color      : $grey;
                  text-align: left;
              }
          }
  
          .orderBreakdown {
              padding-left : 15px;
  
              .orderBreakdownItem {
                  color        : $primaryColor;
                  font-size    : 15px;
                  margin-bottom: 10px;
                  
                  .orderNumber {
                      font-weight: 700;
                  }
              }
          }
      }
  
      .orderBreakdown {
          .orderBreakdownItem {
              cursor     : pointer;
              
              .orderboxheader {
                  display    : flex;
                  align-items: center;
      
                  .b-icon.bi {
                      font-size : 12px;
                  }
      
                  .orderNumber {
                      margin-right : 10px;
                  }
      
                  .boxname {
                      margin-left : 10px;
                      font-weight : 600;
                      margin-right: 10px;
                  }
              }
  
              .flavorlist {
                  padding-left : 30px;
  
                  .flavorname {
                      &::before {
                          content     : '●';
                          margin-right: 10px;
                      }
                  }
  
              }
          }
  
      }
}
</style>
